<mat-card *ngIf="fournisseur">
    <mat-card-title>
         <span [translate]="'admin.frais.fournisseurs.infos.title'">
        </span>
    </mat-card-title>
    <mat-card-content>
        <form #fournisseurForm="ngForm" name="factures-fournisseurs-generalites" autocomplete="off">
            <div class="row">
                <custom-input [(ngModel)]="fournisseur.raisonSociale"
                              id="raisonSociale"
                              name="raisonSociale"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.raisonSociale"
                              [required]="true"
                              lCol="2"
                              maxlength="100"
                              ngDefaultControl>
                </custom-input>
                <custom-input [ngModel]="fournisseur.actif"
                              [(customModel)]="fournisseur.actif"
                              id="actif"
                              name="actif"
                              customType="checkbox"
                              libelle="admin.frais.fournisseurs.infos.actif"
                              lCol="2"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="fournisseur.siren"
                              id="siren"
                              name="siren"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.siren"
                              lCol="2"
                              maxlength="9"
                              ngDefaultControl>
                </custom-input>

                <label class="col-md-2"><span [translate]="'admin.frais.fournisseurs.infos.adresse'"></span></label>
                <div class="col-md-4">
                    <lieu ngDefaultControl
                          name="adresse"
                          [lieuParam]="lieuParam"
                          [(ngModel)]="localisation"
                          [(lieu)]="localisation">
                    </lieu>
                </div>
            </div>
            <div class="row">
                <custom-input [(ngModel)]="fournisseur.siret"
                              id="siret"
                              name="siret"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.siret"
                              lCol="2"
                              maxlength="14"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="fournisseur.numeroIntracom"
                              id="numeroIntracom"
                              name="numeroIntracom"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.intracommunautaire"
                              lCol="2"
                              maxlength="99"
                              ngDefaultControl>
                </custom-input>
            </div>
            <div class="row">
                <custom-input libelle="admin.frais.fournisseurs.infos.devise"
                              rClass="select-width-auto"
                              customType="select"
                              [selectOptions]="listeDevises"
                              optionValue="code"
                              optionDisplay="code"
                              name="devise"
                              [required]="true"
                              [(ngModel)]="fournisseur.devise"
                              ngDefaultControl></custom-input>
            </div>
            <div class="row">
                <custom-input [(ngModel)]="fournisseur.codeFournisseur"
                              id="codeFournisseur"
                              name="codeFournisseur"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.code"
                              lCol="2"
                              maxlength="200"
                              ngDefaultControl>
                </custom-input>
            </div>
            <div class="row">
                <custom-input ngDefaultControl
                              id="libelleOrga"
                              name="libelleOrga"
                              [(ngModel)]="fournisseur.orga"
                              customType="autocomplete"
                              lCol="2"
                              libelle="admin.frais.fournisseurs.infos.service"
                              optionValue="idOrga"
                              optionDisplay="libelle"
                              autocompleteType="service"
                ></custom-input>
                <custom-input name="compteTiers"
                              id="compteTiers"
                              customType="select"
                              libelle="admin.frais.fournisseurs.infos.compteTiers"
                              [(ngModel)]="fournisseur.compteTiers"
                              optionValue="numero"
                              optionDisplay="libelle"
                              [selectOptions]="listeComptes"
                              ngDefaultControl
                              lCol="2">
                    <option value="">{{ 'admin.frais.fournisseurs.champs.parDefaut' | translate }}</option>
                </custom-input>
            </div>

            <div class="row">
                <custom-input [(ngModel)]="fournisseur.numContrat"
                              id="numContrat"
                              name="numContrat"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.contrat"
                              lCol="2"
                              maxlength="99"
                              ngDefaultControl>
                </custom-input>
                <custom-input [(ngModel)]="fournisseur.compteAuxiliaire"
                              id="compteAuxiliaire"
                              name="compteAuxiliaire"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.compteAuxiliaire"
                              lCol="2"
                              maxlength="20"
                              ngDefaultControl>
                </custom-input>
            </div>

            <div class="row">
                <custom-input name="typeCompte"
                              id="typeCompte"
                              customType="select"
                              libelle="admin.frais.fournisseurs.infos.typeReglement"
                              [(ngModel)]="typeCompte"
                              optionValue="type"
                              optionDisplay="libelle"
                              [selectOptions]="listeTypesCompte"
                              [required]="true"
                              ngDefaultControl
                              lCol="2">
                </custom-input>
                <custom-input [(ngModel)]="fournisseur.conditionPaiement"
                              id="conditionPaiement"
                              name="conditionPaiement"
                              customType="input"
                              libelle="admin.frais.fournisseurs.infos.conditionPaiement"
                              lCol="2"
                              maxlength="50"
                              ngDefaultControl>
                </custom-input>
            </div>
            <div *ngIf="typeCompte === 'IBAN'">
                <div class="row">
                    <custom-input [(ngModel)]="fournisseur.iban"
                                  id="iban"
                                  name="iban"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.infos.iban"
                                  lCol="2"
                                  ngDefaultControl>
                    </custom-input>
                    <custom-input [(ngModel)]="fournisseur.bic"
                                  id="bic"
                                  name="bic"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.infos.bic"
                                  lCol="2"
                                  maxlength="11"
                                  ngDefaultControl>
                    </custom-input>
                </div>
            </div>
            <div *ngIf="typeCompte === 'RIB'">
                <div class="row">
                    <custom-input [(ngModel)]="fournisseur.rib"
                                  id="rib"
                                  name="rib"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.infos.rib"
                                  lCol="2"
                                  ngDefaultControl>
                    </custom-input>
                </div>
            </div>
            <div *ngIf="typeCompte === TypeCompteBancaire.RIB || typeCompte === TypeCompteBancaire.AUTRE">
                <div class="row">
                    <custom-input [(ngModel)]="fournisseur.domiciliation"
                                  id="domiciliation"
                                  name="domiciliation"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.infos.domiciliation"
                                  lCol="2"
                                  maxlength="20"
                                  ngDefaultControl>
                    </custom-input>
                </div>
            </div>
            <div *ngIf="typeCompte === TypeCompteBancaire.AUTRE">
                <div class="row">
                    <custom-input [(ngModel)]="fournisseur.numeroCompte"
                                  id="numeroCompte"
                                  name="numeroCompte"
                                  customType="input"
                                  libelle="admin.frais.fournisseurs.infos.numeroCompte"
                                  lCol="2"
                                  maxlength="30"
                                  ngDefaultControl>
                    </custom-input>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>
<please-wait class="content" *ngIf="!fournisseur"></please-wait>
